<template>
    <div class="modal fade" id="ConfirmDeleteModal" tabindex="-1" role="dialog" aria-labelledby="ConfirmDeleteModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="ConfirmDeleteModalLabel">ยืนยันลบ!!</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <h3 class="text text-danger">มั่นใจแค่ไหนว่าจะลบ??</h3>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="ConFirmDeleteClick()">มั่นใจมาก ลบเลย</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">ไม่ดีกว่า</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {    
        data() {
            return {
                //paginate_data:{}    
            }
        },
        mounted() {
            //console.log('Component mounted.')            
            //console.log(0,this.paginate_data);
        },
        created(){
            //console.log(this.paginate_data);
            //console.log(1,this.paginate_data);
        },
        methods:{          
            ConFirmDeleteClick(){                
                this.$emit('ConFirmDeleteClick');
            }
        },        
    
}
</script>